export const _REPORT_PREVIEW_ITEMS = [
    {
        value: 0,
        label: 'Rom Change Monitoring',
        trans: 'report.components.rom_statistic.name',
    },
    {
        value: 1,
        label: 'CC(chief complaint)',
        trans: 'report.components.c_c_complain',
    },
    {
        value: 2,
        label: 'Expert Opinion',
        trans: 'report.components.expert_opinion',
    }]

export const _REPORT_INFO_COMPONENT_NAMES = [
    {
        value : 0,
        componentName : 'RomGraphSection'
    },
    {
        value : 1,
        componentName : 'ChiefComplainSection'
    },
    {
        value : 2,
        componentName : 'ExpertOpinionSection'
    },
]